import { onDocumentEvent } from '@app/utils/domHelpers'

function handleExportReportChange(event) {
  const exportElement = event.target.closest(
    '[data-behaviour~="export-element"]'
  )

  const loader = exportElement.querySelector(
    '[data-behaviour="export-report-form-loading"]'
  )

  const randomId = `export-element-${Date.now()}`
  exportElement.dataset.identifier = randomId

  if (loader) {
    loader.style.display = 'block'
  }

  /**
   * TODO: The export form .js.erb file is executing JS scripts on load.
   * This should be refactored into just plain text, like the export configuration equivalent is being done.
   */
  return $.get(
    Silverfin.Routes.report_form_exports_path({
      firm_id: Silverfin.currentFirmId,
      company_id: Silverfin.currentCompanyId,
    }),
    { report_id: event.target.value, data_identifier: randomId }
  )
}

export default () =>
  onDocumentEvent(
    document,
    'change',
    '[data-behaviour="export-report-select"]',
    handleExportReportChange
  )
